const mapScripts = (scripts) => {

	const scriptsMap = {};

	for (let i = 0, l = scripts.length; i < l; i++) {

		const source = scripts[i].getAttribute('source');

		if (source !== null) {

			if (scriptsMap[source] === undefined)
				scriptsMap[source] = [];

			const fnOnLoadComplete = scripts[i].getAttribute('onLoadComplete');

			if (fnOnLoadComplete !== null)
				scriptsMap[source].push(fnOnLoadComplete);
		}
	}

	return scriptsMap;
};

const getFileExtension = (file) => {
	if (typeof file !== 'string' || file.length === 0)
		return '';

	return file.split('.').pop();
};

const isJavaScriptFile = (file) => {
	const extension = getFileExtension(file);
	return extension === 'js';
};

const loadScript = (source, onLoadedComplete) => {
	const script = document.createElement('script');
	script.setAttribute('type', 'text/javascript');
	script.setAttribute('src', source);

	if (typeof onLoadedComplete === 'function')
		script.addEventListener('load', () => {
			onLoadedComplete();
		});

	document.body.appendChild(script);
};

export default async scripts => {

	const mappedScripts = mapScripts(scripts);

	for (let key in mappedScripts) {

		const fnOnComplete = () => {
			for (let i = 0, l = mappedScripts[key].length; i < l; i++) {
				if (window[mappedScripts[key][i]] !== undefined)
					window[mappedScripts[key][i]]();
			}
		}

		loadScript(key, fnOnComplete);
	}
};

